module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0612.192b0ce1.jpg";